<template>
  <div class="content-image-text" :class="{ 'content-image-text--with-image': image }">
    <img v-if="image" :src="image" alt="" aria-hidden="true" />
    <p v-if="text">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{ image?: string; text?: string }>()
</script>

<style lang="scss" scoped>
@import 'a-image-text';
</style>
